// SocialLinks.tsx

import React from 'react';
import Link from 'next/link';

interface SocialLink {
  href: string;
  label: string;
  backgroundColor: string;
  logo: string;
  logoColor: string;
}

const socialLinks: SocialLink[] = [
  {
    href: 'https://youtube.com/@Cdaprod',
    label: 'YouTube',
    backgroundColor: '#FF0000',
    logo: 'youtube',
    logoColor: 'white',
  },
  {
    href: 'https://twitter.com/cdasmktcda',
    label: 'Twitter',
    backgroundColor: '#1DA1F2',
    logo: 'twitter',
    logoColor: 'white',
  },
  {
    href: 'https://www.linkedin.com/in/cdasmkt',
    label: 'LinkedIn',
    backgroundColor: '#0077B5',
    logo: 'linkedin',
    logoColor: 'white',
  },
  {
    href: 'https://github.com/Cdaprod',
    label: 'GitHub',
    backgroundColor: '#100000',
    logo: 'github',
    logoColor: 'white',
  },
  {
    href: 'https://sanity.cdaprod.dev',
    label: 'Blog',
    backgroundColor: '#FF5722',
    logo: 'blogger',
    logoColor: 'white',
  },
];

export default function SocialLinks() {
  return (
    <div className="flex flex-wrap justify-center gap-4 p-4 w-full">
      {socialLinks.map((link) => (
        <Link
          key={link.label}
          href={link.href}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block px-3 py-2 rounded-full font-bold text-white"
          style={{
            backgroundColor: link.backgroundColor,
            textDecoration: 'none',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <span
            className="inline-block mr-2"
            style={{
              display: 'inline-block',
              width: 20,
              height: 20,
              backgroundImage: `url('https://cdn.jsdelivr.net/npm/simple-icons@v7/icons/${link.logo}.svg')`,
              backgroundSize: 'cover',
              filter: link.logoColor === 'white' ? 'invert(1)' : 'none',
            }}
          />
          {link.label}
        </Link>
      ))}
    </div>
  );
}